<template>
  <div>
    <AnswersModal
      v-if="showModalSelectedAnswer"
      :uuid="selectedAnswer"
      @closeModal="closeModal"
    />
    <AnalysisModal
      v-if="showModalSelectedAnalisys"
      :distributionId="selectedDistribution"
      :uuid="selectedAnalisys"
      @closeModal="closeModal"
    />
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th>Ticket</th>
          <th>Cliente</th>
          <th>Contato</th>
          <th>Enviado</th>
          <th>Lido</th>
          <th>Finalizado</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in userDistributions" :key="d.uuid">
          <td>{{ d.ticketId }}</td>
          <td>{{ d.name }}</td>
          <td>
            {{ d.contact }}
          </td>
          <td>
            <span class="d-none">{{ d.sendAt }}</span>
            {{ d.sendAt ? dateTimeSqlToDateTimeBR(d.sendAt) : 'Não enviado' }}
          </td>
          <td>
            <span class="d-none">{{ d.readAt }}</span>
            {{ d.readAt ? dateTimeSqlToDateTimeBR(d.readAt) : 'Não lido' }}
          </td>
          <td>
            <span class="d-none">{{ d.finishAt }}</span>
            {{
              d.finishAt
                ? dateTimeSqlToDateTimeBR(d.finishAt)
                : 'Não finalizado'
            }}
          </td>

          <td class="text-center p-1">
            <button
              :title="
                d.hideOnReport == 1
                  ? 'Mensurar resposta no relatório'
                  : 'Ocultar resposta no relatório'
              "
              type="button"
              class="btn btn-icon"
              :class="
                d.hideOnReport == 1
                  ? 'btn-outline-danger'
                  : 'btn-outline-success'
              "
              @click="changeHideOrShow(d.uuid, d.hideOnReport == 1 ? 0 : 1)"
            >
              <i
                class="ph"
                :class="
                  d.hideOnReport == 1 ? 'ph-lightning-slash' : 'ph-lightning'
                "
              ></i>
            </button>
            <button
              v-if="d.sendAt"
              :disabled="!d.finishAt"
              title="Ver respostas"
              type="button"
              class="btn btn-outline-info btn-icon ms-2"
              @click="showAnswers(d.uuid)"
            >
              <i class="ph ph-file-text"></i>
            </button>
            <button
              v-if="d.sendAt"
              :disabled="!d.readAt"
              :title="
                d.analisysCreatedBy == null
                  ? 'Cadastrar análise'
                  : 'Ver análise'
              "
              type="button"
              class="btn btn-icon ms-2"
              :class="
                d.analisysCreatedBy == null
                  ? 'btn-outline-warning'
                  : 'btn-outline-indigo'
              "
              @click="showAnalisys(d.distributionId, d.uuid)"
            >
              <i
                class="ph"
                :class="d.analisysCreatedBy ? ' ph-info' : 'ph-note-pencil'"
              ></i>
            </button>
            <router-link
              v-if="!d.finishAt && d.sendAt"
              type="button"
              class="btn btn-outline-info btn-icon ms-2"
              title="Editar"
              :to="`/surveys/${d.uuid}`"
            >
              <i class="ph ph-eye" />
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AnswersModal from '@/components/distributions/AnswersModal.vue'
import AnalysisModal from '@/components/distributions/AnalysisModal.vue'
import '@/utils/basicDataTableExtend'
import { isSendTranslate } from '@/utils/strings'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'ListUserDistributions',

  props: {
    userDistributions: {
      type: Array,
      required: true,
    },
  },

  components: {
    AnswersModal,
    AnalysisModal,
  },

  emits: ['changeHideOrShow'],

  data() {
    return {
      table: null,
      dateTimeSqlToDateTimeBR,
      showModalSelectedAnswer: false,
      showModalSelectedAnalisys: false,
      selectedAnswer: null,
      selectedAnalisys: null,
      selectedDistribution: null,
      dataTable: {
        id: 'dataTableListDistributions',

        columnDefs: [
          {
            targets: [6],
            width: 220,
          },
        ],
      },
      isSendTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        stateSave: true,
        columnDefs: this.dataTable.columnDefs,
      })
    },

    showAnswers(uuid) {
      this.selectedAnswer = uuid
      this.showModalSelectedAnswer = true
    },

    showAnalisys(distributionId, uuid) {
      this.selectedDistribution = distributionId
      this.selectedAnalisys = uuid
      this.showModalSelectedAnalisys = true
    },

    changeHideOrShow(uuid, hideOnReport) {
      this.$emit('changeHideOrShow', { uuid, hideOnReport })
    },

    closeModal(needRefresh) {
      if (needRefresh) {
        this.$emit('reloadData')
      }
      this.showModalSelectedAnswer = false
      this.showModalSelectedAnalisys = false
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
